var getTrimmedId = function getTrimmedId(id) {
  return id && id.slice(-8);
};
export { getTrimmedId };